import React, { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';
import { Link, Outlet, useLocation } from 'react-router-dom';
import '../assets/css/adminpanel.css';
import '../assets/css/team.css';

const AddTeams = () => {
    const [homeTeam, setHomeTeam] = useState({ name: 'Home Team', color: '#CCCCCC' });
    const [awayTeam, setAwayTeam] = useState({ name: 'Away Team', color: '#CCCCCC' });
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const fetchTeams = async () => {
            try {
                const response = await axiosInstance.get('/board/add-teams');
                setHomeTeam(response.data.homeTeam || { name: 'Home Team', color: '#CCCCCC' });
                setAwayTeam(response.data.awayTeam || { name: 'Away Team', color: '#CCCCCC' });
            } catch (error) {
                console.error('Error fetching team data:', error);
                setErrorMessage('Failed to load team data.');
            }
        };

        fetchTeams();
    }, []);

    const handleSaveTeams = async () => {
        try {
            console.log('Updating teams:', { homeTeam, awayTeam });
            const response = await axiosInstance.post('/board/add-teams', { homeTeam, awayTeam });
            console.log('Teams updated successfully:', response.data);
            setSuccessMessage(response.data.message);
            setErrorMessage('');
        } catch (error) {
            console.error('Error updating teams:', error.response?.data || error.message);
            setErrorMessage('Failed to update teams. Please try again.');
        }
    };
    
    const handleInputClick = (setter) => {
        setter((prevState) => ({ ...prevState, name: '' }));
    };

    return (
        <div className="admin-panel container team">
            <header>
                <h2>Manage Teams</h2>
                <p>Update the names and colors of the Home and Away teams.</p>
                <nav>
                    <span>
                        <Link to="/admin" className="admin-link">Back to Admin Panel</Link>
                    </span>
                </nav>
            </header>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSaveTeams();
                }}
            >
                <div className="grid columns-2">
                    <div className="field-group">
                        <label htmlFor="home-name">Home Team:</label>
                        <div className="input-row">
                            <input
                                type="color"
                                id="home-color"
                                value={homeTeam.color}
                                onChange={(e) =>
                                    setHomeTeam({ ...homeTeam, color: e.target.value })
                                }
                                aria-label="Home Team Color"
                            />
                            <input
                                type="text"
                                id="home-name"
                                value={homeTeam.name}
                                onClick={() => handleInputClick(setHomeTeam)}
                                onChange={(e) =>
                                    setHomeTeam({ ...homeTeam, name: e.target.value })
                                }
                                required
                                aria-label="Home Team Name"
                            />
                        </div>
                    </div>
                    <div className="field-group">
                        <label htmlFor="away-name">Away Team:</label>
                        <div className="input-row">
                            <input
                                type="color"
                                id="away-color"
                                value={awayTeam.color}
                                onChange={(e) =>
                                    setAwayTeam({ ...awayTeam, color: e.target.value })
                                }
                                aria-label="Away Team Color"
                            />
                            <input
                                type="text"
                                id="away-name"
                                value={awayTeam.name}
                                onClick={() => handleInputClick(setAwayTeam)}
                                onChange={(e) =>
                                    setAwayTeam({ ...awayTeam, name: e.target.value })
                                }
                                required
                                aria-label="Away Team Name"
                            />
                        </div>
                    </div>
                </div>
                <button type="submit" className="button button-primary">
                    Save Teams
                </button>
            </form>
            {successMessage && <p className="success-message">{successMessage}</p>}
            {errorMessage && <p className="error-message">{errorMessage}</p>}
        </div>
    );
};

export default AddTeams;